import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from "next/router";
import {
    get_city_saga,
    get_country_saga,
    get_gender_saga,
    get_language_saga
} from "../store/actions/general";

const General = () => {
    const dispatch = useDispatch()
    const city_data = useSelector(state => state.city);
    const country_data = useSelector(state => state.country);
    const gender_data = useSelector(state => state.gender);
    const language = useSelector(state => state.language);
    const notification = useSelector(state => state.notification);

    const get_city = (data) => dispatch(
        get_city_saga(
            data
            // role_code: role_code.value, username: username.value, password: username.value
        )
    );
    const get_country = () => dispatch(
        get_country_saga()
    );
    const get_gender = () => dispatch(
        get_gender_saga()
    )
    const get_language = () => dispatch(
        get_language_saga()
    );
    return {
        get_country,
        get_city,
        city_data,
        country_data,
        get_gender,
        gender_data,
        get_language,
        language,
        notification
    }
}
export default General;